export interface Value {
    configurable: boolean
    enabled: boolean
    possibleDefault: boolean
    properties: { [key: string]: string }
    quantity: Quantity
    selectable: boolean
    selected: boolean
    selectionSource: SelectionSource
    translatedValue: string
    value: string
    valueType: ValueType
    price?: number
    imageUrl?: string
    shortText?: string
    longText?: string
}

export interface Quantity {
    currentQuantity: number
    minimumQuantity: number
    currentMaximumQuantity: number
    maximumQuantity: number
    editable?: boolean
}

export enum ValueType {
    String = "STRING",
    Double = "DOUBLE",
    Integer = "INTEGER",
    Boolean = "BOOLEAN",
    RangeDouble = "RANGE_DOUBLE",
    RangeInteger = "RANGE_INTEGER",
    Drange = "DRANGE"
}

export enum SelectionSource {
    NotSet = "NOT_SET",
    SetByUser = "SET_BY_USER",
    SetByDefault = "SET_BY_DEFAULT",
    SetBySystem = "SET_BY_SYSTEM",
    SetByExternal = "SET_BY_EXTERNAL"
}
